import BaseService from './BaseService'

const ApiService = {
    fetchData(param) {
        return new Promise((resolve, reject) => {
            if (param.method?.toLowerCase() === 'get') {
                param.params = {
                    ...param.params,
                    query_timestamp: Date.now(),
                };
            }
            BaseService(param)
                .then((response) => {
                    resolve(response)
                })
                .catch((errors) => {
                    reject(errors)
                })
        })
    },
}

export default ApiService
